var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"noteContainer",class:_vm.noteClass},_vm._l((_vm.noteArr),function(note,i){return _c('p',{key:note + i,class:_vm.pClass},[_vm._v(" "+_vm._s(note)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }